// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {};

export default shadows;
